export const ISSUES = [
  'Layout',
  'Investing the right pieces',
  'Finding the right products',
  'Storage',
  'Creating WOW factor',
  'Making expensive mistakes',
  'Colour scheme',
  'Combining styles',
  'Meeting all my needs',
];

export const REASONS = [
  'Recently moved',
  'Moving into my first home',
  'Looking to sell or rent',
  'Time for a refresh',
  'Need a professional eye',
  'Extending my home',
  'Moving in together',
  'Downsizing',
  'Accomodate family needs',
];

export const SERVICES = [
  { title: 'Architect' },
  { title: 'Builder' },
  { title: 'Bespoke joinery' },
  { title: 'Painter/decorator' },
  { title: 'Window dressing' },
  { title: 'Upholstery' },
  { title: 'Flooring fitter' },
  { title: 'Kitchen supplier' },
  {
    title: 'One day delivery',
    tooltip:
      'Select if you would like all of your furniture to arrive on the same day. There will be an additional fee for this service.',
  },
  {
    title: 'Delivery & installation',
    tooltip:
      'Select if you would like all of your furniture to arrive and be installed on the same day. There will be an additional fee for this service.',
  },
  { title: 'No Other Services Required' },
];

export const ISSUE_OPTIONS = ISSUES.map(i => ({ value: i, label: i }));
export const REASONS_OPTIONS = REASONS.map(i => ({ value: i, label: i }));
export const SERVICES_OPTIONS = SERVICES.map(i => ({ value: i.title, label: i.title }));



// WEBPACK FOOTER //
// ./app/javascript/common/constants/brief.js